import { contactInfo } from "@/mocks/guagua";

const navGroups = [
  {
    title: "内容导航",
    links: [
      { label: "今日热榜", href: "#hot" },
      { label: "热门分类", href: "#category" },
      { label: "事件短视频", href: "#video" },
      { label: "深度专题", href: "#topic" },
    ],
  },
  {
    title: "关于网站",
    links: [
      { label: "关于我们", href: "#about" },
      { label: "网友热议", href: "#review" },
      { label: "常见问题", href: "#faq" },
      { label: "联系订阅", href: "#contact" },
    ],
  },
];

function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#home" className="flex items-center gap-2">
              <span className="grid h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-bubble-chart-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-background-50">吃瓜视频网</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-100/75">
              聚合全网热点事件短视频，实时跟进热门瓜与焦点视频，陪你一网打尽每一场热闹。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="#contact"
                aria-label="关注微信"
                className="grid h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-accent-500"
              >
                <i className="ri-wechat-fill" aria-hidden="true"></i>
              </a>
              <a
                href="#contact"
                aria-label="联系邮箱"
                className="grid h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-accent-500"
              >
                <i className="ri-mail-fill" aria-hidden="true"></i>
              </a>
              <a
                href="#contact"
                aria-label="微博"
                className="grid h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-accent-500"
              >
                <i className="ri-weibo-fill" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {navGroups.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-medium text-background-50">{group.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.href + link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/75 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="text-sm font-medium text-background-50">联系订阅</h3>
            <p className="mt-4 text-sm text-background-100/75">{contactInfo.slogan}</p>
            <p className="mt-3 text-sm text-background-100/75">
              邮箱：{contactInfo.email}
            </p>
            <a
              href="#contact"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-accent-500 px-5 py-2.5 text-sm whitespace-nowrap text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-notification-3-line" aria-hidden="true"></i>
              订阅热点
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-50/15 pt-6">
          <p className="text-xs text-background-100/60">
            © 2026 吃瓜视频网 版权所有 · 内容聚合仅用于信息分享
          </p>
          <p className="text-xs text-background-100/60">
            尊重原创 · 理性吃瓜 · 一网打尽
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;